import type { LocaleBundle } from '../types.js'

export const fr: LocaleBundle = {
  code: 'fr',
  name: 'Français',
  dict: {
    'common:appName': 'Modern Admin',
    'common:home': 'Accueil',
    'common:search': 'Recherche',
    'common:loading': 'Chargement…',
    'common:save': 'Enregistrer',
    'common:cancel': 'Annuler',
    'common:delete': 'Supprimer',
    'common:create': 'Créer',
    'common:edit': 'Modifier',
    'common:show': 'Afficher',
    'common:back': 'Retour',
    'common:noRecords': 'Aucun enregistrement.',
    'common:noRecordsHint': 'Commencez par créer un nouveau {resource}.',
    'common:noMatchingRecords': 'Aucun enregistrement ne correspond à vos filtres.',
    'common:clearFilters': 'Effacer les filtres',
    'common:confirmDelete': 'Supprimer cet enregistrement ?',
    'common:confirmAction': 'Confirmer l’action',
    'common:confirm': 'Confirmer',
    'common:perPage': 'Par page',
    'common:page': 'Page',
    'common:of': 'sur',
    'common:total': 'Total',
    'auth:login': 'Connexion',
    'auth:logout': 'Déconnexion',
    'auth:email': 'E-mail',
    'auth:password': 'Mot de passe',
    'auth:loginFailed': 'Identifiants invalides.',
    'errors:notFound': 'Introuvable.',
    'errors:forbidden': 'Accès refusé à cette ressource.',
    'errors:server': 'Une erreur est survenue. Veuillez réessayer.',
    'common:resources': 'Ressources',
    'common:actions': 'Actions',
    'action:notFound': 'L\'action « {action} » n\'est pas disponible sur cette ressource.',
    'action:componentMissing': 'Aucun composant nommé « {component} » n’est enregistré.',
    'action:componentMissingHint': 'Enregistrez-le dans le ComponentLoader transmis à <ModernAdminProvider components={…}>.',
    'action:loadFailed': 'Échec du chargement de l\'action.',
    'common:new': 'Nouveau',
    'common:rowsPerPage': 'Lignes par page',
    'common:filter': 'Filtrer {label}…',
    'validation:required': '{label} est requis',
    'validation:invalidNumber': '{label} doit être un nombre valide',
    'validation:invalidInteger': '{label} doit être un entier',
    'validation:invalidEmail': '{label} doit être un e-mail valide',
    'validation:invalidUrl': '{label} doit être une URL valide',
    'validation:invalidDate': '{label} doit être une date valide',
    'validation:invalidUuid': '{label} doit être un UUID valide',
    'validation:tooShort': '{label} doit contenir au moins {min} caractères',
    'validation:tooLong': '{label} doit contenir au plus {max} caractères',
    'validation:notInList': '{label} a une valeur invalide',
    'validation:emptySelection': 'Sélectionnez au moins une valeur pour {label}',
    'toast:created': 'Créé avec succès',
    'toast:saved': 'Enregistré avec succès',
    'toast:deleted': 'Supprimé avec succès',
    'toast:createFailed': 'Échec de la création',
    'toast:saveFailed': 'Échec de l\u2019enregistrement',
    'toast:deleteFailed': 'Échec de la suppression',
    'toast:loadFailed': 'Échec du chargement',
    'toast:validationFailed': 'Veuillez corriger les erreurs et réessayer',
    'common:close': 'Fermer',
    'common:export': 'Exporter',
    'export:title': 'Exporter les enregistrements',
    'export:description': 'Télécharger tous les enregistrements correspondants de {resource} dans un seul fichier.',
    'export:csvHint': 'Valeurs séparées par des virgules',
    'export:jsonHint': 'Tableau JSON structuré',
    'export:downloading': 'Préparation du téléchargement…',
    'export:progress': '{loaded} sur {total} chargés…',
    'export:exported': '{count} enregistrements exportés',
    'export:exportFailed': 'Échec de l\u2019export',
    'common:apply': 'Appliquer',
    'common:clear': 'Effacer',
    'common:filters': 'Filtres',
    'common:columns': 'Colonnes',
    'common:toggleColumns': 'Afficher les colonnes',
    'common:openMenu': 'Ouvrir le menu',
    'common:refresh': 'Actualiser',
    'common:copy': 'Copier',
    'common:copied': 'Copié !',
    'common:applyFilters': 'Appliquer les filtres',
    'common:clearAll': 'Tout effacer',
    'common:any': 'Aucun',
    'common:yes': 'Oui',
    'common:no': 'Non',
    'common:filterPlaceholder': 'Filtrer…',
    'common:loadFailed': 'Échec du chargement : {error}',
    'common:theme': 'Thème',
    'common:language': 'Langue',
    'common:toggleTheme': 'Changer de thème',
    'common:clearSelection': 'Effacer la sélection',
    'common:searchPlaceholder': 'Rechercher…',
    'home:searchResources': 'Rechercher des ressources…',
    'home:noMatchingResources': 'Aucune ressource correspondante.',
    'globalSearch:title': 'Recherche globale',
    'globalSearch:description': 'Rechercher dans toutes les ressources et tous les enregistrements.',
    'globalSearch:trigger': 'Rechercher…',
    'globalSearch:placeholder': 'Rechercher dans toutes les ressources…',
    'globalSearch:hint': 'Commencez à taper pour rechercher dans toutes les ressources.',
    'globalSearch:noResults': 'Aucun enregistrement correspondant.',
    'globalSearch:error': 'Échec de la recherche. Veuillez réessayer.',
    'globalSearch:hotkey': 'Ouvrir la recherche globale',
    'globalSearch:matchedIn': 'dans {field}',
    'globalSearch:recent': 'Recherches récentes',
    'globalSearch:clearRecent': 'Effacer',
    'globalSearch:showAllIn': 'Tout afficher dans {resource}',
    'common:pageOf': 'Page {page} sur {total}',
    'common:firstPage': 'Première page',
    'common:previousPage': 'Page précédente',
    'common:nextPage': 'Page suivante',
    'common:lastPage': 'Dernière page',
    'common:recordsCount': '{count} enregistrements',
    'common:selectedCount': '{count} sélectionné(s)',
    'common:selectRow': 'Sélectionner la ligne',
    'common:selectAll': 'Tout sélectionner',
    'common:deleteSelected': 'Supprimer la sélection',
    'common:bulkDeleteConfirm': 'Supprimer les {count} enregistrements sélectionnés ?',
    'toast:bulkDeleted': '{count} enregistrements supprimés',
    'toast:bulkDeleteFailed': 'Échec de la suppression des enregistrements',
    'common:from': 'De',
    'common:to': 'À',
    'common:sortBy': 'Trier par',
    'common:next': 'Suivant',
    'common:previous': 'Précédent',
    'common:relatedRecords': 'Enregistrements liés',
    'common:viewAll': 'Tout afficher',
    'common:noRelatedRecords': 'Aucun enregistrement lié.',
    'common:preview': 'Aperçu',
    'common:download': 'Télécharger',
    'common:openInNewTab': 'Ouvrir dans un nouvel onglet',
    'common:format': 'Formater',
    'common:invalidJson': 'JSON invalide',
    'common:showPassword': 'Afficher le mot de passe',
    'common:hidePassword': 'Masquer le mot de passe',
    'common:shortcutsHelp': 'Raccourcis clavier',
    'common:shortcutsEmpty': 'Aucun raccourci disponible sur cet écran.',
    'auth:title': 'Connexion',
    'auth:subtitle': 'Saisissez votre e-mail et votre mot de passe',
    'auth:tagline': 'Le panneau d\'administration moderne pour toute stack.',
    'auth:orContinueWith': 'Ou continuer avec',
    'auth:continueWith': 'Continuer avec {provider}',
    'common:chooseFile': 'Choisir un fichier',
    'common:chooseFiles': 'Choisir des fichiers',
    'common:dragAndDrop': 'Glisser-déposer ou',
    'common:chooseAFile': 'choisir un fichier',
    'common:addMoreFiles': 'ajouter d\'autres fichiers',
    'common:uploading': 'Téléversement…',
    'common:uploadingFile': 'Téléversement de {name}…',
    'common:removeFile': 'Supprimer le fichier',
    'common:uploadFailed': 'Échec du téléversement',
    'common:dismiss': 'Fermer',
    'common:openCalendar': 'Ouvrir le calendrier',
    'common:time': 'Heure',
    'common:downloadFailed': 'Échec du téléchargement',
    'richtext:bold': 'Gras',
    'richtext:italic': 'Italique',
    'richtext:strikethrough': 'Barré',
    'richtext:inlineCode': 'Code en ligne',
    'richtext:heading': 'Titre {level}',
    'richtext:bulletList': 'Liste à puces',
    'richtext:numberedList': 'Liste numérotée',
    'richtext:blockquote': 'Citation',
    'richtext:horizontalRule': 'Ligne horizontale',
    'richtext:insertLink': 'Insérer un lien',
    'richtext:undo': 'Annuler',
    'richtext:redo': 'Refaire',
    'richtext:source': 'Source ({format})',
    'richtext:splitView': 'Vue partagée',
    'richtext:visualEditor': 'Éditeur visuel',
    'richtext:fullscreen': 'Plein écran',
    'richtext:exitFullscreen': 'Quitter le plein écran',
    'richtext:urlPrompt': 'URL',
    'common:saving': 'Enregistrement…',
    'common:done': 'Terminé',
    'settings:menuItem': 'Paramètres',
    'settings:noSectionsConfigured': 'Aucune section de paramètres n’est disponible pour ce déploiement.',
    'settings:apiKeys.title': 'Clés API',
    'settings:apiKeys.description': 'Jetons d\'accès programmatique à l\'API d\'administration. Chaque clé porte un ensemble de permissions qui limite les ressources et actions qu\'elle peut invoquer.',
    'settings:apiKeys.actions.create': 'Nouvelle clé',
    'settings:apiKeys.actions.edit': 'Modifier',
    'settings:apiKeys.actions.revoke': 'Révoquer',
    'settings:apiKeys.empty.title': 'Aucune clé API',
    'settings:apiKeys.empty.description': 'Créez votre première clé pour accorder un accès programmatique.',
    'settings:apiKeys.columns.name': 'Nom',
    'settings:apiKeys.columns.start': 'Préfixe',
    'settings:apiKeys.columns.permissions': 'Permissions',
    'settings:apiKeys.columns.expiresAt': 'Expire',
    'settings:apiKeys.columns.enabled': 'Activée',
    'settings:apiKeys.columns.actions': 'Actions',
    'settings:apiKeys.lastUsed': 'Dernière utilisation {date}',
    'settings:apiKeys.expiresNever': 'Jamais',
    'settings:apiKeys.permissions.resource': 'Ressource',
    'settings:apiKeys.permissions.actions': 'Actions',
    'settings:apiKeys.permissions.selectAll': 'Tout sélectionner',
    'settings:apiKeys.permissions.clearAll': 'Tout effacer',
    'settings:apiKeys.permissions.none': 'Aucune permission',
    'settings:apiKeys.permissions.summary': '{resources} ressources · {actions} actions',
    'settings:apiKeys.permissions.noResources': 'Aucune ressource enregistrée.',
    'settings:apiKeys.permissions.selectAllResources': 'Sélectionner toutes les ressources et actions',
    'settings:apiKeys.permissions.clearAllResources': 'Effacer toutes les ressources et actions',
    'settings:apiKeys.editor.titleCreate': 'Nouvelle clé API',
    'settings:apiKeys.editor.titleEdit': 'Modifier la clé API',
    'settings:apiKeys.editor.description': 'Choisissez un nom explicite et n\'accordez que les ressources et actions dont cette clé a réellement besoin.',
    'settings:apiKeys.editor.name': 'Nom',
    'settings:apiKeys.editor.namePlaceholder': 'ex. bot de déploiement CI',
    'settings:apiKeys.editor.expiresInDays': 'Expire dans (jours)',
    'settings:apiKeys.editor.expiresPlaceholder': 'jamais',
    'settings:apiKeys.editor.expiresHint': 'Laissez vide pour ne jamais expirer. Maximum 3650 jours.',
    'settings:apiKeys.editor.permissions': 'Permissions',
    'settings:apiKeys.editor.selectedActions': '{count} sélectionnées',
    'settings:apiKeys.created.title': 'Clé API créée',
    'settings:apiKeys.created.description': 'Copiez la clé maintenant — elle ne sera plus affichée.',
    'settings:apiKeys.created.warning': 'C\'est la seule fois où vous verrez la clé complète. Conservez-la en lieu sûr.',
    'settings:apiKeys.created.reveal': 'Afficher la clé',
    'settings:apiKeys.created.hide': 'Masquer la clé',
    'settings:apiKeys.created.copy': 'Copier',
    'settings:apiKeys.created.copied': 'Copiée',
    'settings:apiKeys.notice.revoked': 'Clé API révoquée',
    'settings:apiKeys.notice.updated': 'Clé API mise à jour',
    'settings:apiKeys.notice.copied': 'Copiée dans le presse-papiers',
    'settings:apiKeys.notice.copyFailed': 'Impossible de copier dans le presse-papiers',
    'settings:apiKeys.confirmRevoke.title': 'Révoquer la clé API',
    'settings:apiKeys.confirmRevoke.description': 'Révoquer « {name} » ? Tout service utilisant cette clé cessera immédiatement de fonctionner.',
    'settings:webhooks.title': 'Webhooks',
    'settings:webhooks.description': 'Send signed HTTP notifications when records are created, updated, or deleted.',
    'settings:webhooks.actions.create': 'New webhook',
    'settings:webhooks.actions.test': 'Test',
    'settings:webhooks.notice.saved': 'Webhook saved',
    'settings:webhooks.notice.deleted': 'Webhook deleted',
    'settings:webhooks.notice.testQueued': 'Test notification queued',
    'settings:webhooks.confirmDelete.title': 'Delete webhook',
    'settings:webhooks.confirmDelete.description': 'Delete "{name}"? Delivery history for this webhook will also be removed.',
    'settings:webhooks.empty.title': 'No webhooks yet',
    'settings:webhooks.empty.description': 'Create a webhook to notify external systems about admin changes.',
    'settings:webhooks.columns.name': 'Name',
    'settings:webhooks.columns.resource': 'Resource',
    'settings:webhooks.columns.events': 'Events',
    'settings:webhooks.columns.enabled': 'Enabled',
    'settings:webhooks.columns.actions': 'Actions',
    'settings:webhooks.deliveries.title': 'Recent deliveries',
    'settings:webhooks.deliveries.status': 'Status',
    'settings:webhooks.deliveries.event': 'Event',
    'settings:webhooks.deliveries.attempt': 'Attempt',
    'settings:webhooks.deliveries.response': 'Response',
    'settings:webhooks.deliveries.createdAt': 'Created',
    'settings:webhooks.editor.titleCreate': 'New webhook',
    'settings:webhooks.editor.titleEdit': 'Edit webhook',
    'settings:webhooks.editor.description': 'Choose target URL, events, filters, and optional payload projection.',
    'settings:webhooks.editor.name': 'Name',
    'settings:webhooks.editor.url': 'URL',
    'settings:webhooks.editor.resource': 'Resource',
    'settings:webhooks.editor.allResources': 'All resources',
    'settings:webhooks.editor.secret': 'Signing secret',
    'settings:webhooks.editor.enabled': 'Enabled',
    'settings:webhooks.editor.events': 'Events',
    'settings:webhooks.editor.payloadFields': 'Payload fields',
    'settings:webhooks.editor.payloadFieldsHint': 'Restrict the payload to specific fields. Leave all unchecked to include the full record. Useful to avoid sending sensitive columns.',
    'settings:webhooks.editor.headers': 'Headers',
    'settings:webhooks.editor.headersHint': 'Custom HTTP headers sent with every delivery.\n\nExample:\n{\n  "Authorization": "Bearer <token>",\n  "X-Source": "modern-admin"\n}\n\nUseful for auth tokens, Slack incoming webhook URLs stored as a header, or endpoint-specific signatures.',
    'settings:webhooks.editor.filters': 'Filters',
    'settings:webhooks.editor.filtersHint': 'Deliver only when the record matches all conditions (AND semantics). Leave empty to deliver for every matching event.\n\nExample:\n{\n  "status": "published",\n  "role": "admin"\n}\n\nNote: delete events bypass field filters because the record no longer exists.',
    'settings:webhooks.editor.secretHint': 'Random string used to sign each delivery with HMAC-SHA256. Verify the X-Webhook-Signature header on your server to ensure the request is genuine.',
    'chart:dashboard': 'Tableau de bord',
    'chart:addChart': 'Ajouter un graphique',
    'chart:newChart': 'Nouveau graphique',
    'chart:editChart': 'Modifier le graphique',
    'chart:deleteChart': 'Supprimer le graphique',
    'chart:noCharts': 'Aucun graphique',
    'chart:noChartsHint': 'Ajoutez un graphique pour commencer à surveiller vos données.',
    'chart:addGroup': 'Ajouter un groupe',
    'chart:newGroup': 'Nouveau groupe',
    'chart:editGroup': 'Modifier le groupe',
    'chart:deleteGroup': 'Supprimer le groupe',
    'chart:saveGroup': 'Enregistrer le groupe',
    'chart:groupName': 'Nom du groupe',
    'chart:groupNamePlaceholder': 'p. ex. Indicateurs commerciaux',
    'chart:groupNameRequired': 'Le nom du groupe est requis',
    'chart:groupOrder': 'Ordre du groupe',
    'chart:order': 'Ordre',
    'chart:orderHint': 'Les plus petites valeurs apparaissent en premier.',
    'chart:moveToGroup': 'Déplacer vers le groupe',
    'chart:moveChart': 'Déplacer le graphique',
    'chart:moveGroup': 'Groupe',
    'chart:moveNoGroups': "Aucun groupe pour l'instant.",
    'chart:moveNoGroupsHint': "Créez d'abord un groupe pour organiser vos graphiques.",
    'chart:deleteChartConfirm': 'Supprimer ce graphique ?',
    'chart:deleteChartConfirmHint': 'Cette action est irréversible.',
    'chart:deleteGroupConfirm': 'Supprimer ce groupe ?',
    'chart:deleteGroupConfirmHint': 'Le groupe et ses {count} graphique(s) seront définitivement supprimés.',
    'chart:title': 'Titre',
    'chart:titlePlaceholder': 'ex. Nouveaux utilisateurs par jour',
    'chart:untitled': 'Sans titre',
    'chart:chartType': 'Type de graphique',
    'chart:resource': 'Ressource',
    'chart:groupBy': 'Regrouper par',
    'chart:step': 'Pas',
    'chart:metric': 'Métrique',
    'chart:aggregateField': 'Champ d\'agrégation',
    'chart:selectField': 'Sélectionner un champ…',
    'chart:saveChart': 'Enregistrer le graphique',
    'chart:typeLine': 'Ligne',
    'chart:typeArea': 'Aire',
    'chart:typeBar': 'Barres',
    'chart:typePie': 'Camembert',
    'chart:stepDay': 'Jour',
    'chart:stepWeek': 'Semaine',
    'chart:stepMonth': 'Mois',
    'chart:stepYear': 'Année',
    'chart:metricCount': 'Nombre',
    'chart:metricSum': 'Somme',
    'chart:metricAvg': 'Moyenne',
    'chart:noData': 'Aucune donnée pour la période sélectionnée',
    'chart:loadError': 'Impossible de charger les données du graphique',
    'chart:value': 'Valeur',
    'dashboard:vis': 'Visualisation',
    'dashboard:visKpi': 'KPI',
    'dashboard:visLine': 'Ligne',
    'dashboard:visArea': 'Aire',
    'dashboard:visBar': 'Barres',
    'dashboard:visPie': 'Camembert',
    'dashboard:metricCount': 'Nombre',
    'dashboard:metricSum': 'Somme',
    'dashboard:metricAvg': 'Moyenne',
    'dashboard:metricMin': 'Min',
    'dashboard:metricMax': 'Max',
    'dashboard:builder.range': 'Période',
    'dashboard:builder.filters': 'Filtres',
    'dashboard:builder.filtersHint': "Restreindre le jeu de données avant l'agrégation. Cochez un filtre pour l'afficher au-dessus du graphique.",
    'dashboard:builder.quickFilterHint': 'Afficher ce filtre au-dessus du graphique sur le tableau de bord.',
    'dashboard:builder.quickFilterToggle': 'Exposer {field} comme filtre rapide',
    'dashboard:range.7d': '7j',
    'dashboard:range.30d': '30j',
    'dashboard:range.90d': '90j',
    'dashboard:range.1y': '1an',
    'dashboard:range.all': 'Tout',
    'dashboard:range.custom': 'Personnalisé',
    'dashboard:widget.previousPeriod': 'vs. période précédente',
    'dashboard:widget.deltaUp': '+{value} ({percent}%)',
    'dashboard:widget.deltaDown': '−{value} ({percent}%)',
    'dashboard:widget.deltaFlat': '{value} ({percent}%)',
    'dashboard:widget.shrink': 'Réduire à la moitié',
    'dashboard:widget.expand': 'Étendre sur toute la ligne',
    'dashboard:widget.toggleSql': 'Afficher le SQL',
    'dashboard:widget.unsupported': 'Les graphiques ne sont pas encore pris en charge pour votre base de données.',
    'dashboard:widget.truncatedWarning': 'Affichage de données partielles — trop de lignes pour agréger toute la plage.',
    'dashboard:widget.showAll': 'Tout afficher',
    'dashboard:widget.hideAll': 'Tout masquer',
    'dashboard:seriesTotal': 'Total',
    'dashboard:seriesOther': 'Autres',
    'dashboard:seriesNull': 'Vide',
    'dashboard:builder.dateField': 'Champ de date',
    'dashboard:builder.dateFieldHint': "L'axe X est groupé par cette colonne de date.",
    'dashboard:builder.secondaryGroupBy': 'Répartition',
    'dashboard:builder.noBreakdown': 'Série unique',
    'dashboard:builder.topN': 'Max. séries',
    'dashboard:builder.width': 'Largeur',
    'dashboard:width.half': 'Moitié',
    'dashboard:width.full': 'Pleine largeur',
    'dashboard:builder.comparePrevious': 'Comparer à la période précédente',
    'dashboard:builder.comparePreviousHint': 'Superpose la période précédente de même durée en ligne pointillée et affiche la variation à côté du titre.',
    'dashboard:builder.comparePreviousDisabled': 'Indisponible avec une répartition.',
    'dashboard:builder.transform': 'Transformation des valeurs',
    'dashboard:builder.transformHint': 'Appliquée aux valeurs avant affichage — p. ex. diviser par 100 pour afficher les centimes en euros.',
    'dashboard:builder.transformAdd': 'Ajouter une étape',
    'dashboard:builder.transformRemove': "Supprimer l'étape",
    'dashboard:builder.opDivide': 'Diviser par',
    'dashboard:builder.opMultiply': 'Multiplier par',
    'dashboard:builder.opAdd': 'Ajouter',
    'dashboard:builder.opSubtract': 'Soustraire',
    'dashboard:builder.format': 'Format des valeurs',
    'dashboard:builder.formatStyle': 'Style',
    'dashboard:builder.formatNumber': 'Nombre',
    'dashboard:builder.formatCurrency': 'Devise',
    'dashboard:builder.formatPercent': 'Pourcentage',
    'dashboard:builder.formatCurrencyCode': 'Code de devise',
    'dashboard:builder.formatDecimals': 'Décimales',
    'dashboard:builder.formatCompact': 'Nombres compacts (12,5 k)',
    'dashboard:builder.formatPrefix': 'Préfixe',
    'dashboard:builder.formatSuffix': 'Suffixe',
    'dashboard:builder.color': 'Couleur de la série',
    'dashboard:widget.previousSeries': '{label} (période précédente)',
    'dashboard:widget.editColors': 'Modifier les couleurs',
    'dashboard:widget.colorsTitle': 'Couleurs des séries',
    'dashboard:widget.colorCustom': 'Personnalisé',
    'dashboard:widget.colorAuto': 'Automatique',
    'dashboard:widget.colorPick': 'Choisir une couleur',
    'dashboard:builder.tabData': 'Données',
    'dashboard:builder.tabDisplay': 'Affichage',
    'dashboard:builder.tabFilters': 'Filtres',
    'dashboard:builder.filtersEmpty': 'Cette ressource n’a aucun champ filtrable.',
    'history:revisions': 'Révisions',
    'history:noRevisions': 'Aucune révision pour le moment',
    'history:loadError': 'Impossible de charger l’historique des modifications',
    'history:revert': 'Restaurer',
    'history:confirmRevert': 'Restaurer cette révision ?',
    'history:revertSuccess': 'Révision restaurée',
    'history:revertFailed': 'Impossible de restaurer la révision',
    'history:unknownUser': 'Utilisateur inconnu',
    'history:changes': 'modifications',
    'history:compareTo': 'Comparer à',
    'history:storedDiff': 'Diff des changements',
    'history:op.create': 'Créé',
    'history:op.update': 'Mis à jour',
    'history:op.delete': 'Supprimé',
    'diff:added': 'Ajouté',
    'diff:changed': 'Modifié',
    'diff:removed': 'Supprimé',
    'diff:before': 'Avant',
    'diff:after': 'Après',
    'diff:noChanges': 'Aucune modification de champ enregistrée',
    'audit:title': 'Activité',
    'audit:resource': 'Ressource',
    'audit:action': 'Action',
    'audit:recordId': 'ID enregistrement',
    'audit:userId': 'ID utilisateur',
    'audit:allResources': 'Toutes les ressources',
    'audit:allActions': 'Toutes les actions',
    'audit:noEvents': 'Aucune activité pour le moment',
    'audit:records': 'enregistrements',
    'audit:loadError': 'Impossible de charger l’activité',
    'audit:by': 'par {user}',
    'audit:viewRecord': 'Voir l’enregistrement',
    'audit:viewChanges': 'Voir les modifications',
    'audit:hideChanges': 'Masquer les modifications',
    'audit:noDiff': 'Détails des modifications indisponibles',
    'audit:loadDiffError': 'Échec du chargement des modifications',
    'audit:action.new': 'Enregistrement créé',
    'audit:action.edit': 'Enregistrement mis à jour',
    'audit:action.delete': 'Enregistrement supprimé',
    'audit:action.bulkDelete': 'Enregistrements supprimés',
    'audit:action.login': 'Connexion',
    'audit:action.apiKeyCreate': 'Clé API créée',
    'audit:action.apiKeyUpdate': 'Clé API mise à jour',
    'audit:action.apiKeyDelete': 'Clé API supprimée',
    'audit:virtualResource.auth': 'Authentification',
    'audit:virtualResource.apiKeys': 'Clés API',
    'audit:prevPage': 'Précédent',
    'audit:nextPage': 'Suivant',
    'audit:dateRangePlaceholder': 'Sélectionner une plage de dates',
    'keyValue:noMatches': 'Aucune correspondance — appuyez sur Entrée pour conserver « {value} ».',
    'aiAssistant:queue.cancel': 'Retirer de la file',
    'aiAssistant:title': 'Assistant IA',
    'aiAssistant:fab.label': 'Ouvrir l’assistant IA',
    'aiAssistant:fab.short': 'IA',
    'aiAssistant:description': 'Posez des questions sur les enregistrements, relations, rapports et tendances de données.',
    'aiAssistant:notConfigured.title': 'L’assistant n’est pas configuré',
    'aiAssistant:notConfigured.description': 'Ajoutez la clé API OpenRouter dans les paramètres pour activer l’assistant IA en lecture seule.',
    'aiAssistant:notConfigured.openSettings': 'Ouvrir les paramètres',
    'aiAssistant:tryAsking': 'Essayez de demander :',
    'aiAssistant:tryAsking.example1': 'Quels clients ont le plus de publications ?',
    'aiAssistant:tryAsking.example2': 'Affiche les enregistrements récemment créés d’une ressource.',
    'aiAssistant:tryAsking.example3': 'Explique les relations entre des enregistrements précis.',
    'aiAssistant:thinking': 'Réflexion',
    'aiAssistant:thinkingProgress': 'Réflexion ({progress}%)',
    'aiAssistant:input.placeholder': 'Posez une question sur vos données…',
    'aiAssistant:input.hint': 'Entrée pour envoyer · Maj+Entrée pour une nouvelle ligne',
    'aiAssistant:send': 'Envoyer le message',
    'aiAssistant:newChat': 'Nouveau chat',
    'aiAssistant:history': 'Historique des chats',
    'aiAssistant:history.empty': 'Aucun chat précédent',
    'aiAssistant:noText': 'Voici les enregistrements liés trouvés00a0:',
    'aiAssistant:fallback.noToolResult': 'La requête a été exécutée, mais le modèle n’a pas renvoyé de réponse textuelle. Précisez la question ou activez les journaux de débogage pour inspecter le résultat de l’outil.',
    'aiAssistant:fallback.noRows': 'Aucun enregistrement trouvé pour cette requête.',
    'aiAssistant:fallback.rowsFound': 'Lignes trouvées00a0: {count}.',
    'aiAssistant:taskFailed': 'Échec de la tâche de l’assistant IA',
    'aiAssistant:settings.title': 'Assistant IA',
    'aiAssistant:settings.description': 'Configurez le widget de chat flottant, le modèle et le comportement côté serveur.',
    'aiAssistant:settings.enabled': 'Activé',
    'aiAssistant:settings.disabled': 'Désactivé',
    'aiAssistant:settings.configured': 'Configuré',
    'aiAssistant:settings.apiKeyRequired': 'Clé API requise',
    'aiAssistant:settings.readOnly': 'Lecture seule',
    'aiAssistant:settings.provider': 'Fournisseur : {provider}',
    'aiAssistant:settings.enableLabel': 'Activer l’assistant',
    'aiAssistant:settings.enableHint': 'Contrôle la visibilité du widget flottant et du point de terminaison de chat.',
    'aiAssistant:settings.modelLabel': 'Modèle OpenRouter',
    'aiAssistant:settings.apiKeyLabel': 'Clé API OpenRouter',
    'aiAssistant:settings.apiKeyHint': 'Laissez vide pour conserver la clé enregistrée côté serveur.',
    'aiAssistant:settings.systemPromptLabel': 'Surcharge du prompt système',
    'aiAssistant:settings.systemPromptPlaceholder': 'Instructions optionnelles spécifiques au projet',
    'aiAssistant:settings.accessTitle': 'Modèle d’accès',
    'aiAssistant:settings.accessDescription': 'L’assistant actuel est limité à l’inspection en lecture seule via les actions de ressource.',
    'aiAssistant:settings.futureToolsReady': 'Prêt pour de futurs outils',
    'aiAssistant:settings.save': 'Enregistrer les paramètres',
    'aiAssistant:settings.saving': 'Enregistrement…',
    'aiAssistant:settings.saved': 'Paramètres de l’assistant IA enregistrés',
    'aiAssistant:settings.empty': 'Aucun paramètre disponible.',
    'filter:op.co': 'Contient',
    'filter:op.nco': 'Ne contient pas',
    'filter:op.sw': 'Commence par',
    'filter:op.ew': 'Se termine par',
    'filter:op.eq': 'Est égal à',
    'filter:op.neq': 'N\'est pas égal à',
    'filter:op.empty': 'Est vide',
    'filter:op.nempty': 'N\'est pas vide',
    'filter:op.in': 'Est l\'un de',
    'filter:op.gt': 'Supérieur à',
    'filter:op.lt': 'Inférieur à',
    'filter:op.between': 'Entre',
    'filter:searchValues': 'Rechercher dans la liste…',
    'filter:selectAll': 'Tout sélectionner',
    'filter:noValues': 'Aucune valeur trouvée',
    'common:newRecord': 'Nouveau {name}',
    'common:editRecord': 'Modifier {name} #{id}',
    'common:themeLight': 'Clair',
    'common:themeDark': 'Sombre',
    'common:themeSystem': 'Système',
    'common:ok': 'OK',
    'common:select': 'Sélectionner…',
    'common:removeItem': 'Supprimer {title}',
    'common:nSelectedAddMore': '{count} sélectionné(s) — en ajouter',
    'common:pickRecords': 'Choisir des enregistrements',
    'common:managePickRecords': 'Gérer la sélection ({count})',
    'common:pickRecordsFrom': 'Choisir dans {name}',
    'common:draftRestored': 'Brouillon non enregistré restauré',
    'common:undoDraftRestore': 'Annuler',
    'aiFill:button': 'Remplir avec l’IA',
    'aiFill:dialogTitle': 'Remplir le formulaire depuis une photo',
    'aiFill:dialogDescription': 'Téléversez une image — l’IA extraira les valeurs et remplira le formulaire.',
    'aiFill:fillButton': 'Reconnaître',
    'aiFill:processing': 'Reconnaissance de l’image…',
    'aiFill:success': '{count} champ(s) rempli(s)',
    'aiFill:errorNoFields': 'Cette ressource n’a aucun champ remplissable par l’IA.',
    'aiFill:errorGeneric': 'Échec du remplissage par l’IA : {message}',
    'aiFill:noValues': 'L’IA n’a pu extraire aucune valeur de cette image.',
    'aiFill:applied': "L'IA a rempli {count} champ(s). Annulable ci-dessous.",
    'wizard:stepOf': 'Étape {current} sur {total}',
    'wizard:products.step1': 'Informations de base',
    'wizard:products.step2': 'Tarification',
    'wizard:products.step3': 'Médias et tags',
    'common:invalidValue': 'Valeur invalide',
    'common:collapseSidebar': 'Réduire la barre latérale',
    'common:expandSidebar': 'Développer la barre latérale',
    'common:toggleSidebar': 'Basculer la barre latérale',
    'common:sidebarTitle': 'Barre latérale',
    'common:sidebarNavigation': 'Menu de navigation',
    'cache:title': 'Cache',
    'cache:description': 'État du cache et performances par ressource sur cette réplique.',
    'cache:load.error': 'Impossible de charger les métriques du cache',
    'cache:load.retry': 'Réessayer',
    'cache:reset.action': 'Réinitialiser les métriques',
    'cache:reset.loading': 'Réinitialisation des métriques du cache…',
    'cache:reset.success': 'Métriques du cache réinitialisées',
    'cache:reset.error': 'Échec de la réinitialisation des métriques',
    'cache:metric.hitRate': 'Taux de succès',
    'cache:metric.requests': 'Lectures du cache',
    'cache:metric.avgCompute': 'Calcul moyen',
    'cache:metric.errors': 'Erreurs',
    'cache:unit.ms': '{value} ms',
    'cache:quarantine.title': 'Tags en quarantaine',
    'cache:quarantine.description': "Ces tags contournent le cache jusqu'à la réussite de l'invalidation.",
    'cache:invalidate.title': 'Invalider le cache de la ressource',
    'cache:invalidate.description': 'Supprime les listes et enregistrements de la ressource sur les répliques configurées.',
    'cache:invalidate.resource': 'Ressource',
    'cache:invalidate.action': 'Invalider le cache',
    'cache:invalidate.loading': 'Invalidation du cache…',
    'cache:invalidate.success': 'Cache de la ressource invalidé',
    'cache:invalidate.error': "Échec de l'invalidation du cache de la ressource",
    'cache:table.title': 'Métriques par espace de noms',
    'cache:table.empty': 'Aucune activité du cache enregistrée.',
    'cache:instance': 'Réplique {id}',
    'cache:table.namespace': 'Espace de noms',
    'cache:table.resource': 'Ressource',
    'cache:table.hits': 'Succès',
    'cache:table.misses': 'Échecs',
    'cache:table.computes': 'Calculs',
    'cache:table.coalesced': 'Regroupés',
    'cache:table.errors': 'Erreurs',
  },
}
